 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		90: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"80d3fc6","1":"18c7164","2":"0c45a7c","3":"dbbb398","4":"96a36cb","5":"b5ebf19","6":"e87a850","7":"cc2d3d8","8":"9c9b458","9":"7e1f846","10":"1814d76","11":"5c128e6","12":"438cd89","13":"e85c435","14":"d29462b","15":"2632e0b","16":"c39c926","17":"72bd68b","18":"ab1e557","19":"4b3d16f","20":"ad8ce42","21":"4aff72c","22":"4d67754","23":"6850dcd","24":"07cc2bb","25":"907addc","26":"b068ec2","27":"67ccc4b","28":"1961b3e","29":"bf38655","30":"dc3d857","31":"3a6ee44","32":"265b200","33":"5d13f9e","34":"bc6b664","35":"c808d42","36":"2d6ca7f","37":"de8fc6a","38":"0411fee","39":"707e079","40":"d6c4f99","41":"3083bf5","42":"dce76e5","43":"50180fa","44":"83c073c","45":"bdb4bb9","46":"6dd42da","47":"d09e125","48":"b5d4640","49":"ccd64f3","50":"d28d16f","51":"5cdf5af","52":"316edca","53":"de30248","54":"bdbc5c3","55":"62b9b56","56":"9057b93","57":"1da2c6c","58":"0d7cbbf","59":"d7faf0b","60":"c7af4c7","61":"6032747","62":"c2b8eee","63":"982d1ae","64":"e53bad7","65":"1e94d36","66":"6e10c34","67":"a656e53","68":"16afa42","69":"19c001b","70":"5d43b75","71":"195ef13","72":"a9060be","73":"46e49ef","74":"b1846f0","75":"34ee46b","76":"d04c918","77":"23a37f6","78":"1d78dca","79":"ab63af1","80":"bf41c99","81":"2aa74f2","82":"fca65f3","83":"3e4f246","84":"6a434be","85":"7afb4f7","86":"c5de684","87":"37feff8","88":"fa249b3","89":"8f91480","92":"950777a","93":"bc7b401","94":"acc8490","95":"3dfdfa7","96":"58e9f0c","97":"a5f1b17","98":"60b0abc","99":"1d9498e","100":"45bda00","101":"4cba95d","102":"f406bc9","103":"0c80e7b","104":"0a50102","105":"773313f","106":"2c9fc19","107":"2bf17c7","108":"699b594","109":"a376d3f","110":"daf1ee7","111":"a967c99","112":"43194ef","113":"3ce2399","114":"0f18da4","115":"8c213e7","116":"9b070b8","117":"b957e9a","118":"e7ed52d","119":"5206ba3","120":"8dc9814","121":"e80e839","122":"0c72fca","123":"0170da9","124":"76fbd5d","125":"4e61ee8","126":"04f5a38","127":"62d6f84","128":"178d358","129":"036efb3","130":"8310ff2","131":"cb2a145","132":"2dd8e42","133":"c1cce05","134":"46327bd","135":"c44ce0a","136":"6312c12","137":"9b2eae1","138":"877b2c1","139":"6cd71ea","140":"a1ff196","141":"842a66d","142":"cf88e97","143":"35909f4","144":"4e789cb","145":"8edb1c6","146":"9a808ba","147":"d81fb17","148":"4f63f20","149":"183b47f","150":"8e00366","151":"a06d093","152":"16d7fdb","153":"a4a6edb","154":"21736f3","155":"e9fee73","156":"c5d20e8","157":"1c62fff","158":"194f630","159":"4c2b9d1","160":"b6a822f","161":"fcc745e","162":"545c5cb","163":"1eee3c2","164":"5634614","165":"78896b4","166":"1ea0f76","167":"94a7ecc","168":"744f190","169":"74bd085","170":"47d9ce9","171":"5207624","172":"105dc24","173":"8e7925e","174":"2d1cef0","175":"c350465","176":"da17701","177":"c7b730c","178":"4d9d60c","179":"00926b2","180":"eea20bb","181":"044cf0d","182":"06be11b","183":"da240ef","184":"b004522","185":"4eb1cd8","186":"dc126fc","187":"965b59a","188":"8064f45","189":"f5399eb","190":"c5c9b4f","191":"d650067","192":"49fafdc","193":"e6a5c8b","194":"f53ba3c","195":"3f4e89a","196":"ed2ec07","197":"cceb880","198":"dff12e9","199":"2604761","200":"c0e61a5","201":"c3e23d5","202":"e2a3bd9","203":"b3f25d4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/cms/veranstaltungen/teencamp_2026/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([165,91]);
 	// run deferred modules when ready
 	return checkDeferredModules();
